import { render, staticRenderFns } from "./QiangSet.vue?vue&type=template&id=4939a72f&"
import script from "./QiangSet.vue?vue&type=script&lang=js&"
export * from "./QiangSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports